var render = function render(){var _vm=this,_c=_vm._self._c;return _c('flex-layout',[_c('UserRoleSetupModal',{attrs:{"users":_vm.users,"roles":_vm.roles}}),_c('page-header',{attrs:{"heading":" User Role SetUp","guard":this.$route.meta.guard}}),_c('UserRoleTable',{attrs:{"tableHeading":_vm.tableHeading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }